module.exports = __webpack_public_path__ + "static/media/image-2.99040039.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Apteligent/image-2.png
// module id = 252
// module chunks = 0